// Typed access to the NEXT_PUBLIC_* variables, safe to import from client
// code. It reads only the client half of the registry
// (`secrets.registry.client.ts`), so the browser bundle never carries the
// names of server secrets. Server code imports `env.ts`, which exposes these
// keys too.

import { createEnv } from '@t3-oss/env-nextjs';

import { clientRuntimeEnv, pickClientSchemas } from './secrets.registry.client.ts';

/** Test runners (Vitest sets these) have no env vars; SKIP_ENV_VALIDATION opts out. */
export const skipEnvValidation =
  process.env.NODE_ENV === 'test' ||
  !!process.env.VITEST ||
  !!process.env.VITEST_WORKER_ID ||
  !!process.env.SKIP_ENV_VALIDATION;

/**
 * Build-time production flag, safe on both client and server: Next.js inlines
 * `process.env.NODE_ENV` into both bundles ('production' for Vercel prod +
 * preview builds, 'development' for `next dev`). Centralized here so the rest of
 * the app never reads `process.env` directly (the `no-process-env` rule).
 */
export const isProductionRuntime = process.env.NODE_ENV === 'production';
export const isDevelopmentRuntime = process.env.NODE_ENV === 'development';

export const env = createEnv({
  client: pickClientSchemas(),
  // Vercel env pull writes "" for encrypted vars — treat empty strings as
  // undefined so optional vars don't fail .min(1) checks.
  emptyStringAsUndefined: true,
  runtimeEnv: clientRuntimeEnv,
  skipValidation: skipEnvValidation,
});
